import { useEffect, useRef, useState } from 'react';
import { PwaInstallPrompt } from './PwaInstallPrompt';
import { registerConsumerPwa } from './registerPwa';
import './pwa.css';

export function PwaUpdateNotice() {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
  const activateRef = useRef<((worker: ServiceWorker) => void) | null>(null);
  useEffect(() => {
    const subscription = registerConsumerPwa(setWaitingWorker);
    activateRef.current = subscription.activate;
    return () => {
      activateRef.current = null;
      subscription.dispose();
    };
  }, []);
  return (
    <>
      <PwaInstallPrompt suspended={waitingWorker !== null} />
      {waitingWorker && (
        <aside className="pwa-update-notice" role="status" aria-live="polite" aria-label="Обновление приложения">
          <span className="pwa-update-notice__title">Доступно обновление Хоппера</span>
          <div className="pwa-update-notice__actions">
            <button type="button" className="pwa-update-notice__update" onClick={() => {
              activateRef.current?.(waitingWorker);
              setWaitingWorker(null);
            }}>Обновить</button>
            <button type="button" className="pwa-update-notice__later" onClick={() => setWaitingWorker(null)}>Позже</button>
          </div>
        </aside>
      )}
    </>
  );
}
